const parseConfig = async (config, configDefTypesMap) => {
  _.map(config, (val, key) => {
    config[key] === undefined && delete config[key]
    if (configDefTypesMap[key].type === 'object' && typeof config[key] !== 'object') {
      config[key] = JSON.parse(val)
    }
  })

  if (config.file !== undefined && config.file instanceof Weaver.File) {
    const uploadedFile = await config.file.upload()
    config.file = uploadedFile.id()
  }

  return config
}

export const cleanUpNewTask = async ({ config = {}, functionalityName, functionalityVersion, branch, configDefTypesMap }) => {
  const parsedConfig = await parseConfig(config, configDefTypesMap)
  return {
    userId: Weaver.getInstance().currentUser().id(),
    branch: branch,
    functionalityName: functionalityName.join('.'),
    functionalityVersion,
    config: parsedConfig
  }
}

export const cleanUpEditedTask = async (scheduleUid, { config = {}, configDefTypesMap }) => {
  const parsedConfig = await parseConfig(config, configDefTypesMap)
  return {
    user: Weaver.getInstance().currentUser().id(),
    scheduleUid,
    config: parsedConfig
  }
}
